<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <b-media class="text-center ml-5 mr-5">
            </b-media>
        </base-header>
        <b-container class="container-fluid mt--7">

            <b-row>
                <b-col col sm="12">
                    <b-card no-body>
                        <div class="card shadow">
                            <div class="card-header bg-transparent">
                                <div>
                                    <h3 class="float-left mb-0">
                                        {{ $t('message.add') + ' ' + $t('message.followUp') }}
                                    </h3>
                                </div>

                                <div class="card-body">
                                    <div class="card-title ml-3">
                                    </div>
                                    <b-container>
                                        <section>
                                            <b-form class="mt-4">
                                                <b-container>
                                                    <b-row class="mt-3">
                                                        <b-col md="6" sm="12">
                                                            <span class="obligatoire">*</span>

                                                            <b-form-group
                                                                    id="patient-group"
                                                                    :label="$t('message.select')+' '+$tc('message.patients',1)"
                                                                    label-for="patient">
                                                                <!-- Options -->
                                                                <select
                                                                    required
                                                                    id="patient"
                                                                    v-model="$v.form.patient_id.$model"
                                                                    class="form-control is-invalid border-light retirerBordure"
                                                                >
                                                                    <option v-for="item in mPatients" :value="item.value" :key="item.value">
                                                                        {{ item.text }}
                                                                    </option>
                                                                </select>

                                                                <b-form-invalid-feedback v-if="errorshasField('patient_id')">
                                                                    {{ getErrorsField('patient_id') }}
                                                                </b-form-invalid-feedback>

                                                                <b-form-invalid-feedback v-if="$v.form.patient_id.isPatientExist">
                                                                </b-form-invalid-feedback>

                                                                <b-form-invalid-feedback v-if="!$v.form.patient_id.required">
                                                                    {{ $t('message.requiredField') }}
                                                                </b-form-invalid-feedback>

                                                            </b-form-group>
                                                        </b-col>
                                                    </b-row>

                                                    <b-row class="mt-3">
                                                        <b-col md="6" sm="12">
                                                            <span class="obligatoire">*</span>

                                                            <b-form-group
                                                                    id="state-group"
                                                                    :label="$t('message.select')+' '+$tc('message.category',1)"
                                                                    label-for="state">
                                                                <!-- Options -->
                                                                <select id="state" v-model="$v.form.categorie_id.$model" required
                                                                        class="form-control is-invalid border-light retirerBordure"
                                                                >
                                                                    <option v-for="item in followUpCategories" :value="item.id" :key="item.value">
                                                                        {{ $t(item.nom) }}
                                                                    </option>
                                                                </select>

                                                                <b-form-invalid-feedback v-if="errorshasField('categorie_id')">
                                                                    {{ getErrorsField('categorie_id') }}
                                                                </b-form-invalid-feedback>

                                                                <b-form-invalid-feedback v-if="$v.form.categorie_id.$error">
                                                                    {{ $t('message.requiredField') }}
                                                                </b-form-invalid-feedback>

                                                            </b-form-group>
                                                        </b-col>
                                                    </b-row>

                                                    <b-row>
                                                        <b-col md="6" sm="12">
                                                            <b-form-group
                                                                    id="motif-group"
                                                                    :label="$tc('message.reasons',1)"
                                                                    label-for="motif">
                                                                <b-form-textarea
                                                                        id="motif"
                                                                        v-model="$v.form.motifs.$model"
                                                                        :state="$v.form.motifs.$dirty ? !(errorshasField('motifs') || $v.form.motifs.$error) : null"
                                                                        placeholder=""
                                                                ></b-form-textarea>
                                                                <b-form-invalid-feedback v-if="errorshasField('motifs')">
                                                                    {{ getErrorsField('motifs') }}
                                                                </b-form-invalid-feedback>

                                                                <b-form-invalid-feedback v-if="$v.form.motifs.$error">
                                                                    {{ $t('message.requiredField') }}
                                                                </b-form-invalid-feedback>

                                                            </b-form-group>

                                                        </b-col>
                                                    </b-row>

                                                    <!--<b-row>
                                                        <b-col md="6" sm="12">
                                                            <b-form-group
                                                                    id="specialties-group"
                                                                    :label="$tc('message.specialties',2)"
                                                                    label-for="specialties"
                                                            >
                                                                <select
                                                                    id="specialties"
                                                                    v-model="$v.form.specialties.$model"
                                                                    @change="clearErrorField('consultationTypes')"
                                                                    class="form-control is-invalid retirerBordure"
                                                                    required
                                                                    multiple
                                                                >
                                                                    <option data-placeholder="true"></option>
                                                                    <option v-for="item in consultationTypes" :key="item.id" :value="item.id">
                                                                        {{ item.name }}
                                                                    </option>
                                                                </select>
                                                                <span v-if="errorshasField('consultationTypes')" style="color:red">
                                                                    {{getErrorsField('consultationTypes')}}
                                                                </span>
                                                            </b-form-group>
                                                        </b-col>
                                                    </b-row>-->

                                                    <b-row class="mt-3">
                                                        <b-col md="6" sm="12">
                                                            <span class="obligatoire">*</span>

                                                            <b-form-group
                                                                    id="responsable-group"
                                                                    :label="$t('message.select')+' '+$t('message.manager')"
                                                                    label-for="responsable">
                                                                <!-- Options -->
                                                                <select
                                                                        required
                                                                        multiple
                                                                        id="responsable"
                                                                        v-model="$v.form.responsable.$model"
                                                                        class="form-control is-invalid border-light retirerBordure"
                                                                >
                                                                    <option v-for="item in mContributors" :value="item.id" :key="item.id">
                                                                        {{ item.nom }}
                                                                    </option>
                                                                </select>

                                                                <b-form-invalid-feedback v-if="errorshasField('responsable')">
                                                                    {{ getErrorsField('responsable') }}
                                                                </b-form-invalid-feedback>

                                                            </b-form-group>
                                                        </b-col>
                                                    </b-row>

                                                    <b-row class="">
                                                        <b-col md="6" sm="12">
                                                            <b-button @click="onSubmit" variant="primary">
                                                                {{ $t('message.save') }}
                                                            </b-button>
                                                        </b-col>
                                                    </b-row>
                                                </b-container>
                                            </b-form>
                                        </section>
                                    </b-container>
                                </div>
                            </div>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
	import Vue from 'vue';
    import {mapGetters} from "vuex";
	import * as _ from "lodash";
	import {required} from 'vuelidate/lib/validators';
	import SlimSelect from "slim-select";

    export default {
        name: "AddFollowUp",

        computed: {
            ...mapGetters([
				"practitioners",
				"controlDoctors",
                "patients",
                "consultationTypes",
                "followUpCategories",
                "followed",
                'hasAssistante',
            ]),

			mPatients: function() {
				let pArray = [];

				_.forEach(this.patients, function(patient) {
					if (typeof patient.user == 'object' && patient.user !== null && patient.user.isMedicasure){
						let user = patient.user;
						if (typeof patient.dossier == "object"){
							let dossier  = patient.dossier;
							let prenom = (user.prenom != null && user.prenom) ?  user.prenom : '' ;
							prenom =  prenom.toLowerCase();
							let text = (user.nom).toUpperCase()+" "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
							pArray.push({text: text, value: patient.dossier.id });
						}
					}
				});

				return pArray;
			},

			mPractitioners: function() {
				let pArray = [];

				_.forEach(_.orderBy(this.practitioners,['created_at'],['desc']), function(practitioner) {
					let p = {};
					if((typeof practitioner.user == 'object') && (!_.isNull(practitioner.user)) ){
						let prenom = practitioner.user.prenom != 'null' && !_.isNull(practitioner.user.prenom) ? practitioner.user.prenom : '';
						prenom =  prenom.toLowerCase();
						p.nom =  (practitioner.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
						p.id = practitioner.user.id;
						if (p.nom.length >0){
							pArray.push(p);
						}
					}

				});

				return pArray;
			},

			mDoctors: function() {
				let dArray = [];

				_.forEach(_.orderBy(this.controlDoctors,['created_at'],['desc']), function(doctor) {
					let d = {};
					if((typeof doctor.user == 'object') && (!_.isNull(doctor.user))){
						let prenom = doctor.user.prenom != null ?  doctor.user.prenom : "";
						prenom =  prenom.toLowerCase();
						d.nom =  (doctor.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
						d.id = doctor.user.id;

						if (d.nom.length >0){
							dArray.push(d);
						}
					}

				});

				return dArray;
			},

			mContributors:function () {
				let cArray = [];
				return cArray.concat(this.mDoctors,this.mPractitioners);
			},
        },

        data() {
            return {
				form:{
					patient_id: '',
					responsable: [],
					motifs: '',
					etat: '',
					categorie_id: '',
					specialties: [],

					// this field is hidden and its value if filled automatically
					slug: ''
				},
                followedPatients: [],
				offset: 0,
				limit: -1,
            };
        },
        watch: {
			followedPatients: function(n, o) {
            	// console.log('followedPatients => ', n);
            },
			followed: function(newValue, o) {
				this.followedPatients = newValue.map(item => ({
                    id: item.dossier.id,
                    categoryName: item.categorie ? item.categorie.nom : '',
				}));
            },
        },
        methods: {

			onSubmit() {
            	event.preventDefault();
				this.$v.$touch();

				if (!this.$v.$invalid ) {
					const args = {};
					args.dossier_medical_id = this.form.patient_id;
					args.motifs = this.form.motifs;
					args.categorie_id = this.form.categorie_id;

					args.responsable = this.form.responsable.map(r => ({id: r}));

					args.specialite = this.form.specialties.map(item => {
						return {
							specialite_id: item,
							motifs: this.form.motifs,
							etat: this.form.etat,
							responsable: this.form.responsable,
                        }
                    });

					const slugToRedirect =  this.followUpCategories.find(c => c.id === this.form.categorie_id).slug;

					// console.log('args => ', args);
					// console.log('slugToRedirect => ', slugToRedirect);
					const successMessage = this.$i18n.t('message.followedUpCreated');
					const errorMessages = {
						generic: this.$i18n.t('message.genericError'),
						error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
					};

					const actionToPerform = 'createFollowUp';

					const payload = { args, slugToRedirect, errorMessages, successMessage };

					this.$store.dispatch(actionToPerform, payload).then(() => {

					});
				}
            },

			getListOfFollowUpCategories(){
				this.$store.dispatch('getFollowUpCategories', {args: {}});
			},

			getFollowed(){
				this.$store.dispatch('getFollowed', {args: {}});
			},

			getPatients: function() {
				this.$store.dispatch('getPatients', { args: {} });
			},

            getConsultationTypes() {
				const args = {
					offset: this.offset,
					limit: this.limit
				};

				this.$store.dispatch('getConsultationTypes', { args : args });
			},

			getDoctors() {
				let args = {
					offset: this.offset,
					limit: this.limit
				};

				this.$store.dispatch('getControlDoctors', { args : args });
			},

			getPractitioners() {
				let args = {
					offset: this.offset,
					limit: this.limit
				};

				this.$store.dispatch('getPractitioners', { args : args });
			},

			errorshasField(field) {
				return this.errors ? this.errors.hasOwnProperty(field) : false;
			},

			clearErrorField(field) {
				this.$store.dispatch('clearErrorField', {field});

				this.errorshasField(field);
			},

            // getFollowUp(){
            //     let args = {
            //         // Replace the suivi value by the slug to be recovered in back
            //         suivi: 'value-of-the-follow-up'
            //     };
            //
            //     this.$store.dispatch("getFollowUp", { args });
            // }
			isPatientExist(value) {
				const getFollowedPatient = this.followedPatients.find(item => item.id === Number(value));
				if (getFollowedPatient) {
					this.form.patient_id = '';
					Vue.swal(
						"Patient déjà dans le suivi à l'étape " + getFollowedPatient.categoryName,
						'',
						'error'
					);
					return false;
				}
				return true;
			}
        },
		validations() {
			return {
				form: {
					patient_id:{
						required,
						isPatientExist: this.isPatientExist,
					},

					responsable:{

					},

					motifs:{

					},

					etat:{
						// required
					},

					categorie_id:{
						required
					},

					specialties:{
						// required
					}
				}
			}
		},
        mounted() {
            this.getFollowed();

            this.getListOfFollowUpCategories();

            this.getPatients();

            this.getConsultationTypes();
            // this.getSpecialties();

			// Fetch control doctor list
			this.getDoctors();

			// Fetch practitioner list
			this.getPractitioners();

			new SlimSelect({
				select: '#patient',
				placeholder: 'Select patient',
				limit: 1
			});

			new SlimSelect({
				select: '#state',
				placeholder: 'Select category',
				limit: 1
			});

			new SlimSelect({
				select: '#responsable',
				placeholder: 'Select manager',
				// limit: 1
			});

			// this.getFollowUp();
        }
    }
</script>

















<style scoped lang="scss">
    #followup {
        $primary-color: #2dcecc;
        $gray-color: #ebecf0;
        $white: #fff;
        $black: #121212;

        .followup-content {
            width: 100%;
            min-width: 100%;
            max-width: 100%;
            overflow: hidden;
            overflow-x: scroll;
        }

        .followup-wrapper {
            width: 800px;
            min-width: 800px;
            max-width: 800px;
            overflow: hidden;
            overflow-x: auto;
        }

        .followup-header {
            .followup-add {
                border-radius: 30px;
                background: $primary-color;
                color: $white;
                padding: 7px 25px;

                i {
                    color: $white;
                }
            }
        }

        .followup-column {
            display: inline-block;
            background: $gray-color;
            padding: 10px 5px;
            width: 250px;
            /*width: 30%;*/
            border-radius: 20px;
            border-color: $primary-color;
            vertical-align: top;

            &-content {
                height: 310px;
                min-height: 310px;
                max-height: 310px;
                overflow: hidden;
                overflow-y: auto;

                &::-webkit-scrollbar {
                    width: 5px;
                }

                &::-webkit-scrollbar-track {
                    /*box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);*/
                }

                &::-webkit-scrollbar-thumb {
                    background-color: darkgrey;
                    outline: 1px solid slategrey;
                    border-radius: 15px;
                }
            }

            .followup-column-title p {
                color: $black;
                text-align: center;
            }

            .followup-card-item {
                $padding-left: 15px;

                position: relative;
                background: $white;
                border-radius: 15px;
                padding: $padding-left;
                margin: 0 10px;
                margin-bottom: 20px;
                /*width: 225px;*/

                p {
                    margin-bottom: 0;
                }

                .title {
                    margin-bottom: 4px;
                    position: relative;

                    &:after {
                        content: ' ';
                        position: absolute;
                        bottom: 0;
                        left: -1%;
                        width: 100%;
                        height: 1px;
                        background: #8080807d;
                    }
                }

                .message {
                    p {
                        color: #808080ab;
                        font-size: 15px;
                        white-space: nowrap;
                        width: 144px;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        margin-bottom: 10px;
                    }
                }

                .threedot {
                    position: absolute;
                    top: 0;
                    right: $padding-left;
                    cursor: pointer;

                    /*.threedot-link {
                        span {
                            display: inline-block;
                            width: 8px;
                            height: 8px;
                            background: $primary-color;
                            margin-left: 3px;
                            border-radius: 50%;
                        }

                        &:hover ~ .followup-action {
                            right: 0;
                            opacity: 1;
                        }
                    }*/

                    span {
                        display: inline-block;
                        width: 8px;
                        height: 8px;
                        background: $primary-color;
                        margin-left: 3px;
                        border-radius: 50%;
                    }

                    &:hover {
                        .followup-action {
                            right: 0;
                            opacity: 1;
                        }
                    }

                    .followup-action {
                        background: $white;
                        position: absolute;
                        top: 25px;
                        right: -100px;
                        opacity: 0;
                        transition: all .3s;

                        a {
                            color: $black;
                            display: block;
                            padding: 5px 15px;
                            transition: all .3s;
                            font-weight: 600;

                            &:hover {
                                background: $gray-color;
                                color: $primary-color;
                            }
                        }
                    }
                }

                .label {
                    position: absolute;
                    bottom: -10px;
                    right: 15px;
                    background: $primary-color;
                    border-radius: 25px;
                    padding: 1px 25px;

                    p {
                        font-size: 0.8rem;
                        color: white;
                        font-weight: 600;
                        white-space: nowrap;
                        width: 85px;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }
                }
            }
        }

        .f-first {
            margin-right: 20px;
        }

        .f-second {
            margin-right: 20px;
        }

        .f-third {

        }
    }
</style>
